import React from 'react';
import { FooterActionBar } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ModuleDetails } from '../../../models/PamModels';
import { isRole } from '../../../utilities';
import { TYPES } from '../constants';

import SpfAccounts from './SpfAccounts/SpfAccounts';
import SpfEndpoint from './SpfEndpoint/SpfEndpoint';
import SpfRoles from './SpfRoles/SpfRoles';
import SpfSession from './SpfSession/SpfSession';

import './SidePanelFooter.css';

function SidePanelFooter({
  data,
  credentialRequestOnClick,
  checkoutRoleOnClick,
  dataTestId,
  setIsCheckInModalOpen,
  setIconClickedForRow,
  setCheckInModalKind,
  setSidePanelOnClose,
  setIsExtendModalOpen,
  setSessionToLaunch,
  setIsSessionTargetModalVisible,
  setSessionDetailsForAd,
  isBulkRolesSelectMode,
  isJitForApps,
  setAlertBannerData,
  setIsDownloadOnlyMode,
  className,
}) {
  const classes = classnames('Pam-SidePanelFooter', className);

  const rolesSidePanelFooter = (
    <SpfRoles
      data={data}
      checkoutRoleOnClick={checkoutRoleOnClick}
      isJitForApps={isJitForApps}
    />
  );

  const renderSidePanelFooter = () => {
    switch (data?.type) {
      case TYPES.ACCOUNT:
        return (
          <SpfAccounts
            data={data}
            credentialRequestOnClick={credentialRequestOnClick}
          />
        );
      case TYPES.SESSION:
        return (
          <SpfSession
            data={data}
            credentialRequestOnClick={credentialRequestOnClick}
            setIsCheckInModalOpen={setIsCheckInModalOpen}
            setIconClickedForRow={setIconClickedForRow}
            setCheckInModalKind={setCheckInModalKind}
            setSidePanelOnClose={setSidePanelOnClose}
            setIsExtendModalOpen={setIsExtendModalOpen}
            setSessionToLaunch={setSessionToLaunch}
            setIsSessionTargetModalVisible={setIsSessionTargetModalVisible}
            setSessionDetailsForAd={setSessionDetailsForAd}
            setAlertBannerData={setAlertBannerData}
            setIsDownloadOnlyMode={setIsDownloadOnlyMode}
          />
        );
      case TYPES.ENDPOINT:
        return (
          <SpfEndpoint
            data={data}
            credentialRequestOnClick={credentialRequestOnClick}
            isJitForApps={isJitForApps}
          />
        );
      case TYPES.ROLE:
        return rolesSidePanelFooter;
      default:
        if (isRole(data) && !isBulkRolesSelectMode) {
          return rolesSidePanelFooter;
        }

        return null;
    }
  };

  return (
    <FooterActionBar className={classes} dataTestId={dataTestId}>
      {renderSidePanelFooter()}
    </FooterActionBar>
  );
}

SidePanelFooter.propTypes = {
  data: ModuleDetails,
  dataTestId: PropTypes.string,
  credentialRequestOnClick: PropTypes.func.isRequired,
  checkoutRoleOnClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  setIsCheckInModalOpen: PropTypes.func,
  setIconClickedForRow: PropTypes.func,
  setCheckInModalKind: PropTypes.func,
  setSidePanelOnClose: PropTypes.func,
  setIsExtendModalOpen: PropTypes.func,
  setSessionToLaunch: PropTypes.func,
  setIsSessionTargetModalVisible: PropTypes.func,
  setSessionDetailsForAd: PropTypes.func,
  setAlertBannerData: PropTypes.func,
  setIsDownloadOnlyMode: PropTypes.func,
  isBulkRolesSelectMode: PropTypes.bool.isRequired,
  isJitForApps: PropTypes.bool,
};

SidePanelFooter.defaultProps = {
  data: null,
  dataTestId: null,
  className: null,
  setIsCheckInModalOpen: null,
  setIconClickedForRow: null,
  setCheckInModalKind: null,
  setSidePanelOnClose: null,
  setIsExtendModalOpen: null,
  setSessionToLaunch: null,
  setIsSessionTargetModalVisible: null,
  setSessionDetailsForAd: null,
  setAlertBannerData: null,
  setIsDownloadOnlyMode: null,
  isJitForApps: false,
};

export default SidePanelFooter;
